import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Role } from '../../../core/enum/role.enum';
import { Item } from '../../../core/models/share/item';
import { UserProfile } from '../../../core/models/user/user-profile';
import { SettingService } from '../../../core/services/api/setting.service';
import { ErrorService } from '../../../core/services/error.service';

// INC-317: the backend now makes TransactionPurpose server-mandatory for
// individual investors, so an investor missing it can't clear the
// review-attest screen. This sub-component makes JUST the income & transaction
// fields editable there — transactionPurpose (required) plus grossAnnualIncomeType
// (editable, not gating). Mirrors EmploymentSectionFormComponent: same reactive
// form + getProfileDropdown() source the standalone profile page uses, so
// validation/option parity is automatic.
@Component({
  standalone: false,
  selector: 'app-income-transaction-section-form',
  templateUrl: './income-transaction-section-form.component.html',
  styleUrls: ['./income-transaction-section-form.component.scss'],
})
export class IncomeTransactionSectionFormComponent implements OnInit, OnChanges {
  @Input() profile: UserProfile;
  @Input() role: Role;
  @Input() showFormError = false;

  form: UntypedFormGroup;
  grossAnnualIncome: Item[];
  transactionPurposes: Item[];

  Role: typeof Role = Role;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private settingService: SettingService,
    private errorService: ErrorService,
  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.getDropdowns();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Guarded on `this.form` since the very first change (the one Angular
    // fires before ngOnInit) arrives before buildForm() has run; ngOnInit
    // does that initial seed instead.
    if (changes.profile && this.profile && this.form) {
      this.form.patchValue(this.profile);
    }
  }

  buildForm(): void {
    this.form = this.formBuilder.group({
      // grossAnnualIncomeType is editable but NOT gating (INC-317) — no validator.
      grossAnnualIncomeType: [null],
      // transactionPurpose is the one server-required field for this section.
      transactionPurpose: [
        null,
        this.role === Role.IndividualInvestor ? Validators.required : null,
      ],
    });

    if (this.profile) {
      this.form.patchValue(this.profile);
    }
  }

  getDropdowns(): void {
    const observable =
      this.role == Role.IndividualInvestor
        ? this.settingService.getProfileDropdown()
        : this.settingService.getCorporateRepDropdown();

    observable.subscribe({
      next: (data) => {
        this.grossAnnualIncome = data.grossAnnualIncome;
        this.transactionPurposes = data.transactionPurpose;
      },
      error: (err) => this.errorService.showError(err),
    });
  }
}
